// extracted by mini-css-extract-plugin
export var checkbox = "_2i-0";
export var circle = "_2i-3";
export var horizontalContainer = "_2i-7";
export var sm = "_2i-5";
export var switch0 = "_2i-2";
export var switchDisabled = "_2i-8";
export var switchEnabled = "_2i-1";
export var textSwitchContainer = "_2i-9";
export var textSwitchOption = "_2i-a";
export var textSwitchOptionSelected = "_2i-b";
export var verticalContainer = "_2i-6";
export var xs = "_2i-4";